// Valores iniciales para instalaciones existentes. Después, el catálogo de
// etiquetas se administra desde el Dashboard y llega desde la API.
export const DEFAULT_PRODUCT_TAGS = [
  { name: 'Anime', group: 'Temáticas' },
  { name: 'Series', group: 'Temáticas' },
  { name: 'Autos', group: 'Temáticas' },
  { name: 'Deportes', group: 'Temáticas' },
  { name: 'Gaming', group: 'Temáticas' },
  { name: 'Música', group: 'Temáticas' },
  { name: 'Mujer', group: 'Público' },
  { name: 'Hombre', group: 'Público' },
  { name: 'Niños', group: 'Público' },
  { name: 'Retro', group: 'Colecciones' },
  { name: 'Halloween', group: 'Colecciones' },
  { name: 'Navidad', group: 'Colecciones' },
  { name: 'Uruguay', group: 'Colecciones' }
];

export const normalizeProductTag = (tag) => String(typeof tag === 'object' ? tag?.name : tag || '')
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .trim()
  .toLocaleLowerCase('es');

export const getProductTagName = (tag) => String(typeof tag === 'object' ? tag?.name : tag || '').trim();

export const groupProductTags = (tags = DEFAULT_PRODUCT_TAGS) => {
  const groups = new Map();

  tags
    .filter(tag => tag?.isActive !== false && getProductTagName(tag))
    .forEach(tag => {
      const label = String(tag.group || 'Otras').trim() || 'Otras';
      if (!groups.has(label)) groups.set(label, []);
      groups.get(label).push(getProductTagName(tag));
    });

  return [...groups.entries()]
    .map(([label, groupTags]) => ({
      id: normalizeProductTag(label) || 'otras',
      label,
      tags: [...new Set(groupTags)].sort((a, b) => a.localeCompare(b, 'es'))
    }))
    .sort((a, b) => a.label.localeCompare(b.label, 'es'));
};

export const getCanonicalProductTag = (tag, availableTags = DEFAULT_PRODUCT_TAGS) => {
  const normalizedTag = normalizeProductTag(tag);
  const matchingTag = availableTags.find(item => normalizeProductTag(item) === normalizedTag);
  return matchingTag ? getProductTagName(matchingTag) : getProductTagName(tag);
};

export const hasProductTag = (product, tag) => (
  (product.tags || []).some(item => normalizeProductTag(item) === normalizeProductTag(tag))
);
